module.exports = __webpack_public_path__ + "static/media/logos-lamoderna.abe3641b.png";